import api from "api";
import ApiCaller from "api/apiCaller";
import {DictionaryChangelogs, DictionaryChangelog} from "model/dictionary_changelog";
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import {
  Col,
  Row,
  Container,
  Table,
  Button,
} from "reactstrap";
import Select, { ValueType } from "react-select";
import "./index.css";
import { Popup } from "components/Popup";

interface ModalData {
  isOpen: boolean;
  title: string;
  type: string;
  description: string;
  onPressSubmit: Function;
  onPressCancel: Function;
}

interface defaultDict<T> {
  [Key: string]: T
}

type OptionType = { value: string, label: string };

export default function DataDictionaryChangelog() {
  const companyId = api.getCurrentCompanyId();
  const match = useRouteMatch("/dictionary/changelog/:metadata_type/:reference_id");
  const params: any = match?.params;
  const metadataType = params?.metadata_type;
  const referenceId = params?.reference_id;

  const [dictionaryChangelogs, setDictionaryChangelogs] = useState<DictionaryChangelogs>({});
  const [modalData, setModalData] = useState<ModalData>({
    isOpen: false,
    title: "",
    type: "confirm",
    description: "",
    onPressCancel: () => {},
    onPressSubmit: () => {},
  });

  // const [filterField, setFilterField] = useState([]);
  const [filterField, setFilterField] = useState<string>('');

  const handleOnClickRestore = (log: DictionaryChangelog)  => {
    setModalData({
      isOpen: true,
      title: "Confirmation",
      type: "confirm",
      description: `Restore to this version ?`,
      onPressSubmit: () => {restoreVersion(log)},
      onPressCancel: () => {
        setModalData({ ...modalData, ...{ isOpen: false } });
      },
    });
  }

  const handleFilterFieldChange = (selectedStatus: ValueType<OptionType>) => {
    const statuses = (selectedStatus as OptionType[])?.map((item: OptionType) => item.value);
    if (statuses !== undefined) {
      setFilterField(statuses.join(","));
    } else {
      setFilterField('')
    }
  };

  const getDictionaryChangelogs = async () => {
    const res:any = await ApiCaller.get(`dictionary/changelog/${metadataType}/${referenceId}?company_id=${companyId}&fields=${filterField}`);
    if (res.data) {
      setDictionaryChangelogs(res.data);
    }
  };

  const restoreVersion = async (log: DictionaryChangelog) => {
    setModalData({ ...modalData, isOpen: false });

    let requestData: defaultDict<string> = {};
    requestData[log.field_change] = log.value;
    const res:any = await ApiCaller.put(`${metadataType}/${referenceId}?company_id=${companyId}`, requestData);

    if (res.status === 'ok') {
      alert(`${log.field_change} has been restored!`)
    } else {
      alert(`${log.field_change} can't be restored!`)
    }
  }

  useEffect(() => {
    getDictionaryChangelogs();
  }, [filterField]);

  return (
    <Container>
      <Popup
        type={modalData?.type}
        isOpen={modalData?.isOpen}
        title={modalData?.title}
        description={modalData?.description}
        onPressSubmit={modalData?.onPressSubmit}
        onPressCancel={modalData?.onPressCancel}
      />
      <Col xs={12}>
        <h2 className="dictionary-changelog__header">{dictionaryChangelogs.metadata_type} {dictionaryChangelogs.reference_name} Changelog</h2>
        <ul>
          {metadataType !== "dataset" && <li><span><b>Dataset</b></span>: {dictionaryChangelogs?.dataset_name}</li>}
          {metadataType === "column" && <li><span><b>Table</b></span>: {dictionaryChangelogs?.table_name}</li>}
        </ul>
      </Col>
      {(dictionaryChangelogs.filter_field && dictionaryChangelogs.filter_field.length > 1) &&
        <Select
          isMulti
          closeMenuOnSelect={true}
          onChange={handleFilterFieldChange}
          options={dictionaryChangelogs.filter_field}
          placeholder="Filter Field"
        />
      }
      <Col xs={12} className="data-pipeline-log__table__container">
          <Table striped>
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
                <th>Changed By</th>
                <th>Changed At</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {dictionaryChangelogs?.changelogs?.map((log:any, index) =>
                <tr key={index}>
                  <td>{log.field_change}</td>
                  <td className='custom-textarea-multi-line'>{log.value}</td>
                  <td>{log.changed_by}</td>
                  <td>{log.changed_at}</td>
                  <td>
                    {log.rank === 1 ?
                      <span><b>{"Current version"}</b></span>
                      :
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => {handleOnClickRestore(log)}}
                      >
                        Restore to this version
                      </Button>
                    }
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
    </Container>
  );
}
